import type { Transition } from "motion/react"

export const transitions = {
  default: {
    ease: [0.22, 1, 0.36, 1],
    duration: 0.5,
  },
} as const satisfies Record<string, Transition>
